import { MutationTree } from 'vuex';
import { TemplatesState } from './types';

export const mutations: MutationTree<TemplatesState> = {
    setViberTemplates:(state, data) => {
        state.viberTemplates = data
    },

    setViberMultichannelTemplates:(state, data) => {
        state.viberMultichannelTemplates = data
    },

    setViberTemplateItem:(state, data) => {
        state.viberTemplateItem = data
    },
};